import { Icons } from "@ir/ui";
import { useAnalyticsScoreCards } from "@/hooks";
import AnalyticsScoreCard, { ScoreCardConfig } from "./AnalyticsScoreCard";

const CONFIG: ScoreCardConfig = {
  title: "Gross Sales",
  theme: "secondary",
  icon: Icons.Calculator01,
};

const DeductionsGrossSalesCard = () => {
  const { deductionsGrossSales } = useAnalyticsScoreCards();
  return <AnalyticsScoreCard config={CONFIG} data={deductionsGrossSales} />;
};

export default DeductionsGrossSalesCard;
